import { state } from 'cerebral/tags'
import { set, unset } from 'cerebral/operators'
import loadOrderHistory from './loadOrderHistory'

export default [
  set(state`orderHistory.history`, {}),
  set(state`orderHistory.count`, 0),
  set(state`orderHistory.detail`, {}),
  unset(state`orderHistory.currentId`),
  set(state`orderHistory.skip`, 0),
  set(state`orderHistory.assignedTo`, state`app.user.id`),
  set(state`orderHistory.statuses`, [
    'CLOSED',
    'PROCESSING',
    'FAILED',
    'UNDER_ATTEST'
  ]),
  ...loadOrderHistory
]



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/chains/loadMyOrderHistory.js